import React from 'react';
import { Space } from 'antd';

import * as S from './styles';

export function TituloCollapse({ origem, idStatus, setUpdateConsulta, updateConsulta }) {
  const cor =
    idStatus === 6 ? '#D42929' : idStatus === 7 ? '#24A95D' : '#3E3E3E';
    setUpdateConsulta(true);
  return (
    <Space>
      <Space
        style={{
          color: 'red',
        }}
      >
        <SVGComponent cor={cor} />
      </Space>
      <S.Title>Consulta:</S.Title>
{' '}
<S.Title color={cor}>{origem}</S.Title>
    </Space>
  );
}

function SVGComponent({ cor }) {
  return <svg width={36} height={36} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.875 21.031c0 .331-.092.613-.277.844-.184.232-.406.348-.663.348H12.19c-.257 0-.479-.116-.663-.348a1.311 1.311 0 01-.277-.844c0-.324.022-.627.066-.906.044-.28.116-.55.215-.813.1-.261.25-.467.448-.618.2-.15.437-.225.712-.225.375.385.832.577 1.371.577.54 0 .997-.192 1.372-.577.275 0 .512.075.711.225.2.15.35.357.449.618.1.262.171.533.215.813.044.28.066.582.066.906zm-1.125-4.006c0 .481-.164.89-.492 1.227a1.606 1.606 0 01-1.195.506c-.47 0-.868-.169-1.196-.506a1.694 1.694 0 01-.492-1.227c0-.481.164-.89.492-1.227a1.606 1.606 0 011.195-.505c.47 0 .868.168 1.196.505.328.337.492.746.492 1.227zm9 3.754v.577a.285.285 0 01-.08.208.27.27 0 01-.201.081H18.28a.27.27 0 01-.202-.081.285.285 0 01-.079-.208v-.577c0-.084.026-.154.08-.208a.27.27 0 01.201-.081h6.188a.27.27 0 01.202.081c.053.054.079.123.079.208zm-3.375-2.31v.577a.285.285 0 01-.08.208.27.27 0 01-.201.081H18.28a.27.27 0 01-.202-.081.285.285 0 01-.079-.208v-.577c0-.085.026-.154.08-.208a.27.27 0 01.201-.081h2.813a.27.27 0 01.202.081c.053.054.079.123.079.208zm3.375 0v.577a.285.285 0 01-.08.208.27.27 0 01-.201.081H22.78a.27.27 0 01-.202-.081.285.285 0 01-.079-.208v-.577c0-.085.026-.154.08-.208a.27.27 0 01.201-.081h1.688a.27.27 0 01.202.081c.053.054.079.123.079.208zm0-2.31v.577a.285.285 0 01-.08.208.27.27 0 01-.201.081H18.28a.27.27 0 01-.202-.081.285.285 0 01-.079-.208v-.577c0-.084.026-.154.08-.208a.27.27 0 01.201-.081h6.188a.27.27 0 01.202.081c.053.054.079.123.079.208zm1.125 7.507V13.56h-15.75v10.106c0 .078.028.146.084.203a.267.267 0 00.197.086h15.188a.267.267 0 00.197-.086.281.281 0 00.084-.203zM27 12.694v10.972c0 .397-.138.737-.413 1.02a1.337 1.337 0 01-.993.424H10.406c-.386 0-.718-.141-.993-.424A1.409 1.409 0 019 23.666V12.694c0-.397.138-.737.413-1.02.275-.283.607-.424.993-.424h15.188c.386 0 .717.141.993.424.275.283.413.623.413 1.02z"
      fill={cor}
    />
    <rect x={0.5} y={0.5} width={35} height={35} rx={7.5} stroke={cor} />
         </svg>;
}
